export const fundDistributionActionTypes = {
   
  
  ADD_FUND: "ADD_FUND",
  ADD_FUND_SUCCESS: "ADD_FUND_SUCCESS",
  ADD_FUND_ERROR: "ADD_FUND_ERROR",
  ADD_FUND_RESET: "ADD_FUND_RESET",
}
